






















import Vue from "vue";
import storeHelper from "../../../store/store-helper";
import { NewsArticle } from "@infoland/iprova-api";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import { Controllers, Hyperlink } from "@infoland/iprova-api";
import Shared from "../../../shared";
export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "ReadCard",
    components: {},
    props: {
        id: { type: Number, required: true }
    },
    data: function () {
        return {
            newsArticle: null as NewsArticle
        };
    },
    async created() {
        this.newsArticle = storeHelper.newsArticleStore.getNewsArticle;
        this.newsArticle.content = this.newsArticle.content?.replace(/href=".*?hyperlinkloader.aspx\?hyperlinkid=(.{36})"([^>]*>)/gi, function (
            match,
            $1,
            $2
        ) {
            return '<a href="#/hyperlink/' + $1 + '"' + $2.replace('target="_blank"', "");
        });
    }
});
